// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_m-0";
export var skeletonCard = "_m-1";